import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ProfileIcon } from 'src/assets/svg/profile.svg';
import { Divider, Flex, List, Popover, UnstyledButton, Space, Text } from '@mantine/core';
import { ChevronDown } from '@geist-ui/icons';
import { AvailableAccounts } from '@common/components';
import { AccountSwitchOptionsProps } from '@common/types/types';
import LogoutButton from '../LogoutButton';
import { apiInstance } from 'src/services';
import { useAppSelector } from 'src/store';
import { AlertTriangleFill } from '@geist-ui/icons';
import { numberLocalization } from 'src/helpers/numberLocalization';

import styles from './styles.module.scss';

const AccountMenu: FC<AccountSwitchOptionsProps> = ({ options, data, onChange  }) => {
  const [t] = useTranslation('nav');
  const [opened, setOpened] = useState(false);

  const navigateToPayment = (): void => {
    apiInstance.get('payment/portal').then((res) => {
      window.location = res.data.url;
    });
  };
  const { metadata, paymentPlan, subscriptionScannedPages } = useAppSelector((state) => state.payment.data);
  return (
    <Popover trapFocus width={360} opened={opened} onChange={setOpened}>
      <Popover.Target>
        <UnstyledButton
          onKeyDown={(e) => {
            if (e.key === 'ArrowDown') {
              e.preventDefault();
              setOpened(true);
            }
          }}
          onClick={() => setOpened((o) => !o)}
          aria-label={t('accountSettings')}
          className={styles.accountMenu__item}>
          <ProfileIcon role={`${t('accountIconLabel')}`} />
          <ChevronDown role="presentation" />
        </UnstyledButton>
      </Popover.Target>

      <Popover.Dropdown
        data-menu-dropdown
        className={styles.accountMenu}
        onKeyDown={createScopedKeydownHandler({
          siblingSelector: '[data-menu-item]',
          loop: true,
        })}>
        {/* <AvailableAccounts options={options} data={data} onChange={onChange} data-menu-item> */}
          {/* <Divider aria-hidden={true} /> */}

          {/* <List.Item role="menuitem" tabIndex={-1}> */}
            <LogoutButton data-menu-item className={styles.logoutBtn} /> 
          {/* </List.Item> */}
        {/* </AvailableAccounts> */}
      </Popover.Dropdown>
    </Popover>
  );
};

export default AccountMenu;

function getPreviousIndex(current: number, elements: HTMLButtonElement[], loop: boolean): number {
  for (let i = current - 1; i >= 0; i -= 1) {
    if (!elements[i].disabled) {
      return i;
    }
  }

  if (loop) {
    for (let i = elements.length - 1; i > -1; i -= 1) {
      if (!elements[i].disabled) {
        return i;
      }
    }
  }

  return current;
}

function getNextIndex(current: number, elements: HTMLButtonElement[], loop: boolean): number {
  for (let i = current + 1; i < elements.length; i += 1) {
    if (!elements[i].disabled) {
      return i;
    }
  }

  if (loop) {
    for (let i = 0; i < elements.length; i += 1) {
      if (!elements[i].disabled) {
        return i;
      }
    }
  }

  return current;
}

interface GetElementsSiblingsInput {
  /** Selector used to find element siblings, e.g. '[data-tab]' */
  siblingSelector: string;
  /** Determines whether next/previous indices should loop */
  loop?: boolean;
  /** External keydown event */
  onKeyDown?(event: React.KeyboardEvent<HTMLDivElement>): void;
}

export function createScopedKeydownHandler({
  siblingSelector,
  onKeyDown,
  loop = true,
}: GetElementsSiblingsInput) {
  return (event: React.KeyboardEvent<HTMLDivElement>) => {
    onKeyDown?.(event);

    const elements = Array.from(event.currentTarget?.querySelectorAll<HTMLButtonElement>(siblingSelector) || []);

    const current = elements.findIndex((el) => document.activeElement === el);
    const _nextIndex = getNextIndex(current, elements, loop);
    const _previousIndex = getPreviousIndex(current, elements, loop);

    switch (event.key) {
      case 'ArrowUp': {
        event.stopPropagation();
        event.preventDefault();
        elements[_previousIndex].focus();

        break;
      }

      case 'ArrowDown': {
        event.stopPropagation();
        event.preventDefault();
        elements[_nextIndex].focus();

        break;
      }

      case 'Home': {
        event.stopPropagation();
        event.preventDefault();
        !elements[0].disabled && elements[0].focus();
        break;
      }

      case 'End': {
        event.stopPropagation();
        event.preventDefault();
        const last = elements.length - 1;
        !elements[last].disabled && elements[last].focus();
        break;
      }
    }
  };
}
